import { _defineProperty } from "./index13.js";
import { NmcsState } from "./index130.js";
import { getCurrentLength } from "./index131.js";
import { getDoorDistanceFromRight } from "./index132.js";
import { getEntranceCount } from "./index133.js";
import { getLiftCoreCount } from "./index134.js";
import { getStairCoreCount } from "./index135.js";
import { getFireCoreCount } from "./index136.js";
import { getStartClashStatus } from "./index137.js";
import { RG_TYPE } from "@project-rouge/rg-core";
var AggNmcsState = class AggNmcsState extends NmcsState {
	get requiredShift() {
		return this._requiredShift;
	}
	get totalLength() {
		return this._totalLength;
	}
	get corridorLengths() {
		return this._corridorLengths;
	}
	get entranceCount() {
		return this._entranceCount;
	}
	get fireCoreCount() {
		return this._fireCoreCount;
	}
	get liftCoreCount() {
		return this._liftCoreCount;
	}
	get stairCoreCount() {
		return this._stairCoreCount;
	}
	constructor({ gap, sequence = [], totalLength, corridorLengths = [0], requiredShift = 0, data }) {
		super();
		_defineProperty(this, "sequence", []);
		_defineProperty(this, "gap", void 0);
		_defineProperty(this, "data", void 0);
		_defineProperty(this, "_requiredShift", 0);
		_defineProperty(this, "_totalLength", void 0);
		_defineProperty(this, "_corridorLengths", void 0);
		_defineProperty(this, "_entranceCount", void 0);
		_defineProperty(this, "_fireCoreCount", void 0);
		_defineProperty(this, "_liftCoreCount", void 0);
		_defineProperty(this, "_stairCoreCount", void 0);
		_defineProperty(this, "update", (action) => {
			this.sequence.push(action);
			if (this._totalLength === 0) {
				this._totalLength += action.unit.size[0];
				if (this.data.lockEnds[0] === false) {
					const startClosingDistance = this.data.endClosingDistances[0];
					const startEntranceDistance = this.data.endEntranceDistances[0];
					if (!getStartClashStatus({
						action,
						startClosingDistance,
						startEntranceDistance
					})) this._requiredShift = startClosingDistance - (action.doorPosition - .5 * action.doorWidth);
				}
			} else this._totalLength += this.gap + action.unit.size[0];
			this.updateCorridorDistance(action, this._requiredShift);
			if (action.unit.type === RG_TYPE.Entrance) this._entranceCount++;
			if (action.unit.type === RG_TYPE.Core && action.unit.data.hasFireLift) this._fireCoreCount++;
			if (action.unit.type === RG_TYPE.Core && action.unit.data.hasNonFireLift) this._liftCoreCount++;
			if (action.unit.type === RG_TYPE.Core && !action.unit.data.hasFireLift && !action.unit.data.hasNonFireLift) this._stairCoreCount++;
		});
		_defineProperty(this, "clone", () => {
			return new AggNmcsState({
				sequence: this.sequence.slice(),
				totalLength: this._totalLength,
				corridorLengths: this._corridorLengths.slice(),
				gap: this.gap,
				requiredShift: this._requiredShift,
				data: this.data
			});
		});
		this.gap = gap;
		this.data = data;
		this.sequence = sequence;
		this._totalLength = totalLength ?? getCurrentLength(this.sequence, this.gap);
		this._corridorLengths = corridorLengths;
		this._entranceCount = getEntranceCount(this.sequence);
		this._fireCoreCount = getFireCoreCount(this.sequence);
		this._liftCoreCount = getLiftCoreCount(this.sequence);
		this._stairCoreCount = getStairCoreCount(this.sequence);
		this._requiredShift = requiredShift;
	}
	updateCorridorDistance(action, shift = 0) {
		if (action.unit.type === RG_TYPE.Core) this._corridorLengths.push(0);
		else if (this.sequence.length === 1) if (this.data.hasCornerAt[0] === false) this._corridorLengths[0] += Math.max(getDoorDistanceFromRight(action), shift + action.unit.size[0] - this.data.endEntranceDistances[0]);
		else this._corridorLengths[this._corridorLengths.length - 1] += action.unit.size[0] + this.data.distToCore[0];
		else this._corridorLengths[this._corridorLengths.length - 1] += action.unit.size[0];
	}
	finalUpdate(data) {
		this.finishCorridorDistance(data);
	}
	finishCorridorDistance(rulesData) {
		const firstAction = this.sequence[0];
		if (!firstAction) return;
		const shift = rulesData.targetLength - this._totalLength;
		const isShiftedToRight = !rulesData.lockEnds[0] && rulesData.lockEnds[1];
		if (isShiftedToRight && getDoorDistanceFromRight(firstAction) < firstAction.unit.size[0] - this.data.endEntranceDistances[0] + shift) this._corridorLengths[0] += shift - this._requiredShift;
		if (this.data.hasCornerAt[1]) return;
		const lastUnit = this.sequence[this.sequence.length - 1];
		if (!lastUnit && this._corridorLengths[this._corridorLengths.length - 1] !== 0) return;
		const startOfDoorPosFromEnd = getDoorDistanceFromRight(lastUnit) + lastUnit.doorWidth;
		let oppositeDoorPosFromEnd = this.data.endEntranceDistances[1];
		if (!isShiftedToRight) oppositeDoorPosFromEnd -= shift - this._requiredShift;
		const endDoorPos = Math.min(startOfDoorPosFromEnd, oppositeDoorPosFromEnd);
		this._corridorLengths[this._corridorLengths.length - 1] -= endDoorPos;
	}
};
export { AggNmcsState };

//# sourceMappingURL=index138.js.map